import React from 'react';
import ReactDOM from 'react-dom';

import WLT0001_Master from './WLT0001-master';

const getInfoRecordsUrl = document.getElementById('infoRecordsUrl').getAttribute("value").valueOf();
const getNinushiDtlUrl = document.getElementById('ninushiDtlUrl').getAttribute("value").valueOf();
const getSysdateDtlUrl = document.getElementById('sysdateDtlUrl').getAttribute("value").valueOf();

ReactDOM.render(
    <WLT0001_Master
        getInfoRecordsUrl={getInfoRecordsUrl}
        getNinushiDtlUrl={getNinushiDtlUrl}
        getSysdateDtlUrl={getSysdateDtlUrl}
     />
    ,document.getElementById('login_details'));


// WEBPACK FOOTER //
// ./view/WLT0001/WLT0001.jsx